var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_1448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 1.99999C11.5086 1.8249 11.7165 1.686 11.9452 1.59124C12.174 1.49648 12.4192 1.44771 12.6668 1.44771C12.9145 1.44771 13.1596 1.49648 13.3884 1.59124C13.6172 1.686 13.8251 1.8249 14.0002 1.99999C14.1753 2.17509 14.3142 2.38296 14.4089 2.61173C14.5037 2.8405 14.5524 3.0857 14.5524 3.33333C14.5524 3.58095 14.5037 3.82615 14.4089 4.05492C14.3142 4.28369 14.1753 4.49156 14.0002 4.66666L5.00016 13.6667L1.3335 14.6667L2.3335 11L11.3335 1.99999Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_1448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.eb6a48953aa25bf03ed3393aee5017d3.svg";
export { ForwardRef as ReactComponent };